import { ActionTypes } from '../../main/biInterfaces';
import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { Participant } from '@wix/ambassador-challenges-v1-participant/types';
import { biBeforeAndAfter } from '../../../services/biHelpers';
import { createJoinRequest } from '@wix/ambassador-challenges-v1-participant/http';
import { request } from '../../../services/request';
import { getChallengeId } from '../../storage-contexts/Challenge/helpers/getChallengeId';

export async function sendRequestForOwnersApprove(
  flowAPI: ControllerFlowAPI,
  timeZone: string,
  startDate,
): Promise<Participant> {
  const challengeId = await getChallengeId(flowAPI);

  return (
    await biBeforeAndAfter(
      flowAPI.bi,
      ActionTypes.JOIN_REQUEST_CREATE,
      async (actionId) => {
        return (
          await request(
            flowAPI,
            createJoinRequest({
              challengeId,
              memberId: flowAPI.controllerConfig.wixCodeApi.user.currentUser.id,
              timeZone,
              startDate,
              actionId,
            }),
          )
        )?.data;
      },
    )
  ).participant;
}
